// extracted by mini-css-extract-plugin
export default {"mCard":"AE-z","image":"BE-z","imageNoBackground":"CE-z","imageHasCategory":"DE-z","fullWidth":"EE-z"};